import { baseApi } from "..";
import { checkIsAdmin } from "../../../helpers/helpers";

// Define a service using a base URL and expected endpoints
export const prodOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitSublimation: builder.mutation({
      query: ({
        logo_placement_images,
        adult_design_image,
        junior_design_image,
        comments,
        production_order_id,
      }) => ({
        url: `sublimations`,
        method: "POST",
        body: {
          logo_placement_images,
          adult_design_image,
          junior_design_image,
          comments,
          production_order_id,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    getSublimation: builder.query({
      query: ({ id }) => `sublimations/${id}`,
      transformResponse: (response) => response.data,
    }),

    deleteSublimation: builder.mutation({
      query: ({ id }) => ({
        url: `sublimations${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.data,
    }),

    uploadColorCode: builder.mutation({
      query: ({ data }) => ({
        url: `images/sublimation-color-code`,
        method: "POST",
        body: data,
        formData: true,
      }),

      transformResponse: (response) => response.data,
    }),
    uploadLogoPlacement: builder.mutation({
      query: ({ data }) => ({
        url: `images/sublimation-logo-placement`,
        method: "POST",
        body: data,
        formData: true,
      }),

      transformResponse: (response) => response.data,
    }),

    submitEmbroidery: builder.mutation({
      query: ({ data }) => ({
        url: `embroideries`,
        method: "POST",
        body: {
          data,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    uploadEmbroideryImage: builder.mutation({
      query: ({ data }) => ({
        url: `images/embroidery`,
        method: "POST",
        body: data,
        formData: true,
      }),

      transformResponse: (response) => response.data,
    }),

    getEmbroidery: builder.query({
      query: ({ id }) => `embroideries/${id}`,
      transformResponse: (response) => response.data,
    }), 
    
    submitHeatTransfer: builder.mutation({
      query: ({ data }) => ({
        url: `heat-transfers`,
        method: "POST",
        body: {
          data,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    uploadHeatTransferImage: builder.mutation({
      query: ({ data }) => ({
        url: `images/heat-transfer`,
        method: "POST",
        body: data,
        formData: true,
      }),

      transformResponse: (response) => response.data,
    }),

    getHeatTransfer: builder.query({
      query: ({ id }) => `heat-transfers/${id}`,
      transformResponse: (response) => response.data,
    }),

    getFabricDetails: builder.query({
      query: ({ id }) => `production-orders/${id}/fabric-details`,
      transformResponse: (response) => response.data,
    }),

    submitFabricDetails: builder.mutation({
      query: ({ production_order_id, fabrics }) => ({
        url: `production-orders/${production_order_id}/fabric-details`,
        method: "POST",
        body: {
          fabrics,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    getTrimDetails: builder.query({
      query: ({ id }) => `production-orders/${id}/trim-details`,
      transformResponse: (response) => response.data,
    }),

    submitTrimDetails: builder.mutation({
      query: ({ production_order_id, trims }) => ({
        url: `production-orders/${production_order_id}/trim-details`,
        method: "POST",
        body: {
          trims,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    getLabels: builder.query({
      query: ({ id }) => `production-orders/${id}/label-details`,
      transformResponse: (response) => response.data,
    }),

    submitLabels: builder.mutation({
      query: ({ production_order_id, labels }) => ({
        url: `production-orders/${production_order_id}/label-details`,
        method: "POST",
        body: {
          labels,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    getSpecialInstruction: builder.query({
      query: ({ id }) => `production-orders/${id}/instructions-details`,
      transformResponse: (response) => response.data,
    }),

    submitSpecialInstruction: builder.mutation({
      query: ({ production_order_id, comment }) => ({
        url: `production-orders/${production_order_id}/instructions-details`,
        method: "POST",
        body: {
          comment,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    getSpecification: builder.query({
      query: ({ id }) => `production-orders/${id}/specification-details`,
      transformResponse: (response) => response.data,
    }),

    submitSpecification: builder.mutation({
      query: ({ production_order_id, specification }) => ({
        url: `production-orders/${production_order_id}/specification-details`,
        method: "POST",
        body: {
          specification,
        },
      }),
      transformResponse: (response) => response.data,
    }),

    getLabelDetails: builder.query({
      query: ({ id }) => `production-orders/${id}/label-details`,
      transformResponse: (response) => response.data,
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSubmitSublimationMutation,
  useGetSublimationQuery,
  useDeleteSublimationMutation,
  useUploadColorCodeMutation,
  useUploadLogoPlacementMutation,
  useSubmitEmbroideryMutation,
  useUploadEmbroideryImageMutation,
  useGetEmbroideryQuery,
  useSubmitHeatTransferMutation,
  useUploadHeatTransferImageMutation,
  useGetHeatTransferQuery,
  useGetFabricDetailsQuery,
  useSubmitFabricDetailsMutation,
  useGetTrimDetailsQuery,
  useSubmitTrimDetailsMutation,
  useGetLabelsQuery,
  useSubmitLabelsMutation,
  useGetSpecialInstructionQuery,
  useSubmitSpecialInstructionMutation,
  useGetSpecificationQuery,
  useSubmitSpecificationMutation,
  useGetLabelDetailsQuery,
} = prodOrderApi;
